














import { Component, Prop, Vue } from 'vue-property-decorator';
import { NavigationModule } from '@/store/modules/navigation/navigation.store';
import ToggleButton from '@/components/ToggleButton.vue';
import ProfileMenu from '../ProfileMenu.vue';

@Component({
    components: {
        ProfileMenu,
        ToggleButton
    }
})
export default class TopMenu extends Vue {
	@Prop() isLoggedIn!: boolean;

	get IsSidebarActive() {
	    return NavigationModule.showSideNavigation;
	}

	ToggleSideNav() {
	    NavigationModule.ToggleSideNavigation();
	}
}
